import { render, staticRenderFns } from "./BonusStatus.vue?vue&type=template&id=080df6f5"
import script from "./BonusStatus.vue?vue&type=script&lang=js"
export * from "./BonusStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports